<template>
    <div></div>
</template>

<script>
// Note that this probably should live somewhere else, like vuex or vue router
// but for now, this hack gets all js out of the erb templates
export default {
  name: 'tab-router',
  mounted() {
    // If an inbound link contains a specific tab, show it
    const url = document.location.toString();
    if (url.match('#')) {
      const hash = url.split('#')[1];
      // "#matches" opens the "#matches-tab" pane; a pane id like "#tab-3" opens itself
      const link = $(`.nav-tabs a[href="#${hash}-tab"]`);
      (link.length ? link : $(`.nav-tabs a[data-toggle="tab"][href="#${hash}"]`)).tab('show');
    }
  },
};
</script>
